import React from 'react';
import type { TimelineEpic, Objective } from '@/types';
import TimelineBar from './TimelineBar';

interface TimelineRowProps {
  epic: TimelineEpic;
  selectedYear: number;
}

const TimelineRow: React.FC<TimelineRowProps> = ({ epic, selectedYear }) => {
  console.log('TimelineRow rendering for epic:', epic.name, 'Year:', selectedYear);
  console.log('TimelineRow - Epic data:', {
    objectives: epic.objectives?.length || 0,
    milestones: epic.milestones?.length || 0,
    investibleStructure: epic.investibleStructure?.name
  });

  // If epic has no objectives, show a single row with the epic name and timeline bar (if milestones exist)
  if (!epic.objectives || epic.objectives.length === 0) {
    console.log('TimelineRow - No objectives, showing single row');

    return (
      <div className="grid grid-cols-[250px_100px_1fr] hover:bg-[var(--surface-muted)] transition-colors">
        {/* Epic Name */}
        <div className="p-3 border-r border-[var(--border)]">
          <div className="font-medium text-[var(--text)]">{epic.name}</div>
          {epic.investibleStructure && (
            <div className="text-xs text-[var(--muted)] mt-1">
              {epic.investibleStructure.name}
            </div>
          )}
        </div>

        {/* No OKR */}
        <div className="p-3 border-r border-[var(--border)] text-[var(--muted)] text-sm italic">
          No OKRs
        </div>

        {/* Timeline Bar (show if milestones exist) */}
        <div className="p-3 relative">
          {epic.milestones && epic.milestones.length > 0 ? (
            <TimelineBar epic={epic} objective={null as any} selectedYear={selectedYear} />
          ) : (
            <div className="text-xs text-[var(--muted)] italic">No milestones</div>
          )}
        </div>
      </div>
    );
  }

  // Render a row for each objective
  return (
    <>
      {epic.objectives.map((objective: Objective, index: number) => (
        <div
          key={objective.id}
          className="grid grid-cols-[250px_100px_1fr] hover:bg-[var(--surface-muted)] transition-colors"
        >
          {/* Epic Name (only show on first objective row) */}
          <div className={`p-3 border-r border-[var(--border)] ${index > 0 ? 'opacity-0' : ''}`}>
            {index === 0 && (
              <>
                <div className="font-medium text-[var(--text)]">{epic.name}</div>
                {epic.investibleStructure && (
                  <div className="text-xs text-[var(--muted)] mt-1">
                    {epic.investibleStructure.name}
                  </div>
                )}
                {epic.objectives.length > 1 && (
                  <div className="text-xs text-[var(--accent)] mt-1">
                    {epic.objectives.length} OKRs
                  </div>
                )}
              </>
            )}
          </div>

          {/* OKR */}
          <div className="p-3 border-r border-[var(--border)]">
            <div className="text-sm font-medium text-[var(--text)] line-clamp-2">
              {objective.title}
            </div>
          </div>

          {/* Timeline Bar */}
          <div className="p-3 relative">
            <TimelineBar
              epic={epic}
              objective={objective}
              selectedYear={selectedYear}
            />
          </div>
        </div>
      ))}
    </>
  );
};

export default TimelineRow;
